import HTTP from "@/http";

export function postMessage(data = {}) {
  return HTTP({
    url: "api/message",
    method: "POST",
    data,
  });
}
